var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStacked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66699 22.2943V19.4833L12.1751 16.314C12.8968 16.0734 13.6721 16.0436 14.4102 16.2281L18.2368 17.1848C18.4828 17.2463 18.7412 17.2364 18.9818 17.1562L29.3337 13.7056V16.5165L19.8251 19.686C19.1034 19.9266 18.328 19.9563 17.59 19.7718L13.7634 18.8152C13.5174 18.7537 13.2589 18.7636 13.0184 18.8438L2.66699 22.2943Z",
    fill: "#66BB6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.667 9.33644C26.667 8.2642 25.4656 7.63055 24.5807 8.23606L20.4094 11.0903C19.4655 11.7362 18.2901 11.9471 17.1804 11.6697L14.0498 10.8871C13.7162 10.8037 13.3634 10.8524 13.0649 11.0229L6.00547 15.0569C5.59004 15.2943 5.33366 15.7361 5.33366 16.2145V22.667C5.33366 23.4034 5.93061 24.0003 6.66699 24.0003H25.3337C26.07 24.0003 26.667 23.4034 26.667 22.667V9.33644ZM23.0748 6.03529C25.7295 4.21877 29.3337 6.11973 29.3337 9.33644V22.667C29.3337 24.8761 27.5428 26.667 25.3337 26.667H6.66699C4.45785 26.667 2.66699 24.8761 2.66699 22.667V16.2145C2.66699 14.7791 3.43614 13.4537 4.68244 12.7416L11.7418 8.70761C12.6373 8.19589 13.6959 8.04986 14.6965 8.30002L17.8272 9.08268C18.1971 9.17516 18.5889 9.10485 18.9035 8.88954L23.0748 6.03529Z",
    fill: "#673AB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStacked);
export default __webpack_public_path__ + "static/media/stacked.b3c9fce735a68d78b81b09877218266f.svg";
export { ForwardRef as ReactComponent };